import type { JSX } from 'react';

import { StatusTag } from '@bookora/ui';

import { PLAN_LOCK_TAG } from './plan-lock-copy';

import './plan-lock.css';

/**
 * The inert «پلن بالاتر» tag beside a locked tab and a sidebar entry (owner
 * D6: a badge, never hiding). Inert tone and no hint: it labels, it does not
 * act — the tab it sits in explains itself when opened. The caller decides
 * whether to draw it (a lock is known); a tag is never drawn while plan access
 * is unknown, because the lock UI fails open.
 */
export function PlanLockTag(): JSX.Element {
  return (
    <StatusTag tone="inert" icon="lock" className="bk-plan-lock-tag">
      {PLAN_LOCK_TAG}
    </StatusTag>
  );
}

/**
 * A tab label with the tag after it — for a tab strip whose tab is locked.
 * What is SEEN (the label and the tag) is `aria-hidden`; what is HEARD is one
 * visually hidden phrase, «هزینه‌ها (پلن بالاتر)», so a screen reader says the
 * lock once and in words (one text node, so no accessible-name algorithm can
 * drop the space between them).
 */
export function PlanLockedTabLabel({ label }: { label: string }): JSX.Element {
  return (
    <span className="bk-tab-with-tag">
      <span className="bk-visually-hidden">{`${label} (${PLAN_LOCK_TAG})`}</span>
      <span aria-hidden>{label}</span>
      <span aria-hidden>
        <PlanLockTag />
      </span>
    </span>
  );
}
